import { msalInstance, silentRequest } from './msalConfig';
import { tokenRef } from './tokenRef';

let redirectInFlight = false;

/// <summary>
/// Central redirect-to-login helper. Clears the in-memory token, flushes the
/// active account's MSAL cache entry, and triggers an acquireTokenRedirect so
/// the user lands back on the same page after re-auth (state.returnTo).
/// Guards against re-entrancy: many 401s can fire in parallel, but only the
/// first one should actually start the redirect.
/// </summary>
export async function redirectToLogin(): Promise<void> {
  if (redirectInFlight) return;
  redirectInFlight = true;

  tokenRef.current = null;
  try {
    await msalInstance.clearCache();
  } catch {
    // clearCache can throw if there's no active account; ignore.
  }

  const returnTo = window.location.pathname + window.location.search;
  await msalInstance.acquireTokenRedirect({
    ...silentRequest,
    state: returnTo
  });
}
